// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/radialDial.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qhpDtNvkYCkEd31X {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center;
    background-size: contain;
    aspect-ratio: 1;
    width: 255px;
}

.TnYoTZR6z02SOMhw {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--lok-spacing-1);
    height: 100%;
    padding: 58px 20px 38px 42px;
}

.gj9tthU1jccxOO4g {
    display: flex;
    flex-direction: column;
    height: 100%;
}

.idXIlO7zPKAdoM7A {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: var(--lok-spacing-1);
    height: 100%;
}

.rFgXlrU_sK8B9MgU, .hUoMEGsmGTUnYcI_ {
    font-size: 24px;
    font-weight: bold;
    line-height: 1;
    color: var(--lok-color-text-success);
}

.hUoMEGsmGTUnYcI_ {
    align-self: end;
}

._JL56LvECOQ2QGIK {
    font-size: 110px;
    font-weight: bold;
    line-height: .85;
    color: var(--lok-color-text-success);
}

.sNbD5bthoCwylMYz {
    font-size: 32px;
    font-weight: bold;
    line-height: 1;
    color: var(--lok-color-text-success);
}

.iVZBk0buAzEl0wjU {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    padding: 44px 30px 56px 40px;
}

.CYuh5JQ8QKPPAaUJ {
    display: flex;
    align-items: center;
    height: 100%;
}

.ZsmvEPjGN2UovBc_ {
    font-size: 144px;
    line-height: 1;
    font-weight: bold;
    color: var(--lok-color-text-success);
}

.kKeONskTtQ5eIQU6 {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding-top: 21px;
}

.gBr2dK3cqSAmYrCV {
    max-width: 72px;
    font-size: 16px;
    line-height: 1.15;
    font-weight: bold;
    color: var(--lok-color-text-success);
}

.uIkAEN9buWEN1VTE {
    font-size: 48px;
    line-height: 1;
    font-weight: bold;
    color: var(--lok-color-text-success);
}
`, "",{"version":3,"sources":["webpack://./packages/rag/src/components/RadialDial/RadialDial.module.css"],"names":[],"mappings":"AAAA;IACI,2EAAsE;IACtE,wBAAwB;IACxB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;AAChC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,oCAAoC;AACxC","sourcesContent":[".container {\n    background: url('../../assets/radialDial.svg') no-repeat center center;\n    background-size: contain;\n    aspect-ratio: 1;\n    width: 255px;\n}\n\n.variant1__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--lok-spacing-1);\n    height: 100%;\n    padding: 58px 20px 38px 42px;\n}\n\n.variant1__containerInner {\n    display: flex;\n    flex-direction: column;\n    height: 100%;\n}\n\n.upToContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: var(--lok-spacing-1);\n    height: 100%;\n}\n\n.upTo, .lessEdits {\n    font-size: 24px;\n    font-weight: bold;\n    line-height: 1;\n    color: var(--lok-color-text-success);\n}\n\n.lessEdits {\n    align-self: end;\n}\n\n.bigText {\n    font-size: 110px;\n    font-weight: bold;\n    line-height: .85;\n    color: var(--lok-color-text-success);\n}\n\n.percentage {\n    font-size: 32px;\n    font-weight: bold;\n    line-height: 1;\n    color: var(--lok-color-text-success);\n}\n\n.variant2__container {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    height: 100%;\n    padding: 44px 30px 56px 40px;\n}\n\n.variant2__innerContainer {\n    display: flex;\n    align-items: center;\n    height: 100%;\n}\n\n.variant2__number {\n    font-size: 144px;\n    line-height: 1;\n    font-weight: bold;\n    color: var(--lok-color-text-success);\n}\n\n.variant2__right {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding-top: 21px;\n}\n\n.variant2__text {\n    max-width: 72px;\n    font-size: 16px;\n    line-height: 1.15;\n    font-weight: bold;\n    color: var(--lok-color-text-success);\n}\n\n.variant2__decimal {\n    font-size: 48px;\n    line-height: 1;\n    font-weight: bold;\n    color: var(--lok-color-text-success);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qhpDtNvkYCkEd31X`,
	"variant1__container": `TnYoTZR6z02SOMhw`,
	"variant1__containerInner": `gj9tthU1jccxOO4g`,
	"upToContainer": `idXIlO7zPKAdoM7A`,
	"upTo": `rFgXlrU_sK8B9MgU`,
	"lessEdits": `hUoMEGsmGTUnYcI_`,
	"bigText": `_JL56LvECOQ2QGIK`,
	"percentage": `sNbD5bthoCwylMYz`,
	"variant2__container": `iVZBk0buAzEl0wjU`,
	"variant2__innerContainer": `CYuh5JQ8QKPPAaUJ`,
	"variant2__number": `ZsmvEPjGN2UovBc_`,
	"variant2__right": `kKeONskTtQ5eIQU6`,
	"variant2__text": `gBr2dK3cqSAmYrCV`,
	"variant2__decimal": `uIkAEN9buWEN1VTE`
};
export default ___CSS_LOADER_EXPORT___;
